module.exports = __webpack_public_path__ + "static/img/module4-cover.b9910ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/module4-cover.jpg
// module id = LkeZ
// module chunks = 0